function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_391_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_394_",
  d: "M71.325,80c0,11.805-9.604,21.41-21.41,21.41c-5.523,0-10,4.477-10,10v133.181c0,5.523,4.477,10,10,10    c11.805,0,21.41,9.604,21.41,21.41c0,5.523,4.477,10,10,10h349.181c5.523,0,10-4.477,10-10c0-11.805,9.604-21.41,21.409-21.41    c5.523,0,10-4.477,10-10V111.41c0-5.523-4.477-10-10-10c-11.805,0-21.409-9.604-21.409-21.41c0-5.523-4.477-10-10-10H81.325    C75.802,70,71.325,74.477,71.325,80z M421.727,90c3.687,14.815,15.373,26.502,30.188,30.189v115.622    c-14.815,3.687-26.501,15.374-30.188,30.189H90.104c-3.687-14.815-15.374-26.502-30.189-30.189V120.189    C74.731,116.502,86.417,104.816,90.104,90H421.727z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_395_",
  d: "M172.58,49.92c2.64,0,5.21-1.07,7.08-2.93c1.86-1.86,2.92-4.44,2.92-7.07s-1.06-5.21-2.92-7.07    c-1.87-1.86-4.44-2.93-7.08-2.93c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07    S169.95,49.92,172.58,49.92z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_396_",
  d: "M128.94,188.01c2.63,0,5.2-1.07,7.07-2.93c1.86-1.86,2.93-4.43,2.93-7.07c0-2.63-1.07-5.21-2.93-7.07    c-1.86-1.86-4.44-2.93-7.07-2.93c-2.64,0-5.21,1.07-7.08,2.93c-1.86,1.86-2.92,4.44-2.92,7.07c0,2.64,1.06,5.21,2.92,7.07    C123.73,186.94,126.3,188.01,128.94,188.01z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_397_",
  d: "M382.9,188.01c2.63,0,5.21-1.07,7.07-2.93c1.87-1.86,2.93-4.44,2.93-7.07s-1.06-5.21-2.93-7.07    c-1.86-1.86-4.43-2.93-7.07-2.93c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07c0,2.64,1.07,5.21,2.93,7.07    C377.69,186.94,380.27,188.01,382.9,188.01z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_400_",
  d: "M255.578,236.619c32.317,0,58.608-26.292,58.608-58.608s-26.292-58.608-58.608-58.608    c-32.316,0-58.608,26.292-58.608,58.608S223.261,236.619,255.578,236.619z M255.578,139.404c21.289,0,38.608,17.319,38.608,38.608    s-17.32,38.608-38.608,38.608S216.97,199.3,216.97,178.011S234.289,139.404,255.578,139.404z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_401_",
  d: "M468.99,361.01c-1.87-1.86-4.44-2.93-7.07-2.93c-2.64,0-5.21,1.07-7.08,2.93    c-1.86,1.86-2.92,4.43-2.92,7.07c0,2.63,1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.08,2.93c2.63,0,5.2-1.07,7.07-2.93    c1.86-1.86,2.93-4.44,2.93-7.07C471.92,365.45,470.85,362.87,468.99,361.01z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_435_",
  d: "M511.916,39.921c0-5.523-4.477-10-10-10H212.584c-5.523,0-10,4.477-10,10s4.477,10,10,10h279.332v256.146    H20V49.93h112.584c5.523,0,10-4.477,10-10s-4.477-10-10-10H10c-5.523,0-10,4.477-10,10v432.15c0,5.523,4.477,10,10,10h492    c5.523,0,10-4.477,10-10L511.916,39.921z M20,378.08h401.916c5.523,0,10-4.477,10-10s-4.477-10-10-10H20v-32h197.728H492v84H20    V378.08z M20,462.08v-32h472v32H20z"
}));

var SvgCash = function SvgCash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_768_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1421_",
    x: 10,
    y: 368.08,
    style: {
      fill: "#A0E557"
    },
    width: 492,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1850_",
    x: 10,
    y: 420.08,
    style: {
      fill: "#62CD4D"
    },
    width: 492,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1420_",
    x: 10,
    y: 316.08,
    style: {
      fill: "#62CD4D"
    },
    width: 492,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1419_",
    x: 9.916,
    y: 39.921,
    style: {
      fill: "#A0E557"
    },
    width: 492,
    height: 276.159
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1310_",
    style: {
      fill: "#D8FB93"
    },
    d: "M81.325,276h349.181c0-17.347,14.063-31.409,31.409-31.409V111.41   c-17.347,0-31.409-14.062-31.409-31.409H81.325c0,17.347-14.062,31.409-31.409,31.409v133.181   C67.263,244.591,81.325,258.653,81.325,276z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1396_",
    style: {
      fill: "#A0E557"
    },
    cx: 255.578,
    cy: 178.012,
    r: 48.608
  }), _ref2));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash.2619a04c.svg";
export { ForwardRef as ReactComponent };